<template>
  <div class="bg-light-gray mb-2">
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            icon="fas fa-user-plus text-orange"
            icon-size="17px"
            title="Asignar CAAT"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="caats"
              label="Seleccione CAAT:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione un CAAT"
              :error="errors[0]"
              v-model="caat"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handleAssignCaat"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import IconView from 'icon-view';
import locationService from '@/services/api/location.api';

export default {
  name: 'TransferRequest',
  components: {
    IconView,
    ActionButton,
    CustomDropDown,
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: false,
      default: () => null,
    },
    equipmentIds: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      caats: [],
      caat: {},
    };
  },
  async mounted() {
    await this.getCaats();
  },
  methods: {
    async handleAssignCaat() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }
      if (this.item == null && this.equipmentIds.length == 0) {
        this.ShowToast(
          'Alerta',
          'Por favor seleccione al menos un equipo en estatus disponible o procesado.',
          'error'
        );
        return;
      }
      if (this.item != null && this.item.caatId == this.caat.id) {
        this.ShowToast(
          'Alerta',
          'Seleccione un CAAT diferente al que posee el equipo.',
          'error'
        );
        return;
      }
      this.onAssignCaat();
    },
    onAssignCaat() {
      inventoryCatalogService
        .assignCaatToEquipment(
          this.item == null ? this.equipmentIds : [this.item.id],
          this.caat.id
        )
        .then(() => {
          this.ShowToast(
            'Éxito',
            'El CAAT se ha asignado exitosamente.',
            'success'
          );
          this.$emit('close');
        })
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
    },
    async getCaats() {
      const { data: caats } = await locationService.getCaats();
      this.caats = caats;
      if (this.caats.length == 1) {
        this.caat = this.caats[0];
      } else {
        if (this.item == null) {
          this.caat = null;
        } else {
          this.caat = this.caats.find((x) => x.id == this.item.caatId);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dot {
  padding: 19px !important;
}
</style>
